// extracted by mini-css-extract-plugin
export default {"cls1":"Tq_ifpeLT7LULZyZt1AS","cls2":"N_ZuWgLDgSMG9BTaD9wQ Tq_ifpeLT7LULZyZt1AS"};